<script>
import { connect } from 'vuex-connect';
import LanguageButton from '@/launcher/components/shared/LanguageButton.vue';

export default connect({
  gettersToProps: {
    localeName: 'currentLocaleAlias',
    disabled: 'safetyMode',
  },
})('LanguageButton', LanguageButton);
</script>
